export default __webpack_public_path__ + "static/media/ios.ed326682.svg";